import { all } from 'redux-saga/effects';

import DigitalWealthGbi from './gbi';
import DigitalWealthPortfolio from './portfolio';

export default function* DigitalWealth() {
  yield all([DigitalWealthGbi(), DigitalWealthPortfolio()]);
}
